<template>
  <footer>
    <p class="pl-1 text-center text-small">
      Design inspired from
      <a
        href="https://www.behance.net/Ibrahim_Shamss/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Ibrahim Shamss
      </a>
    </p>
    <div class="flex items-center justify-center py-2">
      <p class="pl-1 text-small">Developed by Louis Ko</p>
    </div>
  </footer>
</template>

<script setup></script>

<style scoped>
ul > * {
  @apply flex-1 px-4;
}
</style>
